
import * as types from './actionTypes';
import userService from '../services/UserService';
import customerService from '../services/Customer';

export function ReceivedCurrentUser(userJson) {
    return { type: types.RECEIVE_USER, user: userJson };
}

export function setSelectedUser(userJson) {
    return { type: types.SET_SELECTED_USER, user: userJson };
}

export function updateFullName(user) {
    return { type: types.UPDATE_USER_FULL_NAME, user: user };
}

export function receivedFilteredUsers(filteredUsers) {
    return { type: types.RECEIVED_USERS, filteredUsers: filteredUsers };
}

export function receivedCustomerPreferences(prefs) {
    return { type: types.RECEIVED_CUSTOMER_PREFERENCES, preferences: prefs };
}

export function SetUserFlags(userFlags) {
    return { type: types.UPDATE_USERFLAGS, userFlags: userFlags };
}

export function updateUserLocale(locale) {
    return { type: types.UPDATE_USER_LOCALE, locale: locale };
}

export function ReceivedCustomers(customers) {
    return { type: types.RECEIVED_CUSTOMERS, customers: customers };
}

export function SetCustomer(customer) {
    customerService.set(customer);
    return { type: types.SET_CUSTOMER, customer: customer };
}

export function UpdateWarrantyAccess(id) {
    return function (dispatch) {
        return userService.updateWarrantyAccess(id)
            .then(() => fetchFilteredUsers(dispatch));
    };
}

export function GetFilteredUsers() {
    return function (dispatch) {
        return fetchFilteredUsers(dispatch);
    };
}

function fetchFilteredUsers(dispatch) {
    return userService
        .fetchFilteredUsers()
        .then(filtered => {
            dispatch(receivedFilteredUsers(filtered));
        })
        .catch(error => {
            throw error;
        });
}

let _getCustomersInFlight = null;

export function GetUserCustomers() {
    return async (dispatch, getState) => {
        const existing = getState().user?.customers ?? [];
        if (existing.length > 0) return existing;
        if (_getCustomersInFlight) return _getCustomersInFlight;

        _getCustomersInFlight = customerService.fetchCustomers()
            .then((res) => {
                dispatch(ReceivedCustomers(res));
                return res;
            })
            .finally(() => {
                _getCustomersInFlight = null;
            });

        return _getCustomersInFlight;
    };
}

export function LoadInitialUserCustomers() {
    return GetUserCustomers();
}
